import type { TableProps } from '@aibees/shared/components/table';
import { useAdvanceTableConfigContext } from '../../../context';
import { calculateTableSort } from '../utils';

export function useGetBrowseIdsApiData<T>(
  table?: TableProps<T>,
  returnParam?: string
) {
  const { config } = useAdvanceTableConfigContext();
  if (!config || !config.browseIdsApi) return null;

  const api = config.browseIdsApi(
    {
      sort: table && calculateTableSort(table, config.prependSortingFields),
      ...config.extraFilters,
      size: table?.selection?.size || table?.selection?.count,
      ...table?.selection.extraParam,
      page: 0,
    },
    { return: returnParam || 'id' },
    !!config.browseIdsApi && !!table && !!table.selection.size,
    {
      cacheTime: 0,
      onSuccess: (res) => {
        if (table?.selection) {
          table.selection.onClear();
          table.selection.setIncluded(res);
        }
      },
    },
    table?.selection
      ? {
          onSetExtraParam: table.selection.onSetExtraParam,
          onRemoveExtraParam: table.selection.onRemoveExtraParam,
        }
      : undefined
  );

  return api;
}
